<template>
    <div class="container pt-2">
        <PageTitle main="Minha Empresa" sub="Alterar dados cadastrais da Empresa" />
        <b-form>
            <input id="empresa-id" type="hidden" v-model="empresa.id" />
            <input id="empresa-usuariosativos" type="hidden" v-model="empresa.usuarios_ativos" />
            <div class="row">
                <div class="col-md-5">
                    <b-form-group label="Razão Social:" label-for="empresa-razao">
                        <b-form-input id="empresa-razao" type="text"
                            v-model="empresa.razao" 
                            placeholder="Informe a razao do empresa."
                            :class="{ 'inputError': $v.empresa.razao.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.razao.$touch"/>
                        <span class="error" v-if="!$v.empresa.razao.required && $v.empresa.razao.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.razao.minLength && $v.empresa.razao.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="CNPJ:" label-for="empresa-cnpj">
                        <b-form-input id="empresa-cnpj" type="text"
                            v-model="empresa.cnpj" 
                            placeholder="Informe o CNPJ do empresa."
                            v-mask="'##.###.###/####-##'"
                            :class="{ 'inputError': $v.empresa.cnpj.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.cnpj.$touch"/>
                        <span class="error" v-if="!$v.empresa.cnpj.required && $v.empresa.cnpj.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.cnpj.minLength && $v.empresa.cnpj.$error">Preencha um CNPJ válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Plano:" label-for="empresa-plano">
                        <b-form-select id="empresa-plano" :options="planos" v-model="empresa.plano"
                        :class="{ 'inputError': $v.empresa.plano.$error }"
                        class="textInput"
                        @keydown.tab="$v.empresa.plano.$touch"/>
                        <span class="error" v-if="!$v.empresa.plano.required && $v.empresa.plano.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Ativo:" label-for="empresa-ativo">
                        <b-form-select id="empresa-ativo" :options="ativar" v-model="empresa.ativo"
                        :class="{ 'inputError': $v.empresa.ativo.$error }"
                        class="textInput"
                        @keydown.tab="$v.empresa.ativo.$touch"/>
                        <span class="error" v-if="!$v.empresa.ativo.required && $v.empresa.ativo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Telefone:" label-for="empresa-telefone">
                        <b-form-input id="empresa-telefone" type="tel"
                            v-model="empresa.telefone"
                            placeholder="Informe o telefone do empresa."
                            v-mask="['(##)####-####', '(##)#####-####']"
                            :class="{ 'inputError': $v.empresa.telefone.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.telefone.$touch"/>
                        <span class="error" v-if="!$v.empresa.telefone.required && $v.empresa.telefone.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.telefone.minLength && $v.empresa.telefone.$error">Preencha um telefone válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="E-mail:" label-for="empresa-email">
                        <b-form-input id="empresa-email" type="email"
                            v-model="empresa.email"
                            placeholder="Informe o E-mail do empresa."
                            :class="{ 'inputError': $v.empresa.email.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.email.$touch"/>
                        <span class="error" v-if="!$v.empresa.email.required && $v.empresa.email.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.email.email && $v.empresa.email.$error">Digite um email válido!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="CEP:" label-for="empresa-cep">
                        <b-form-input id="empresa-cep" type="text"
                            v-model="empresa.cep"
                            placeholder="CEP"
                            v-mask="'#####-###'"
                            @keydown.tab="searchCep"
                            :class="{ 'inputError': $v.empresa.cep.$error }"
                            class="textInput"/>
                        <span class="error" v-if="!$v.empresa.cep.required && $v.empresa.cep.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.cep.minLength && $v.empresa.cep.$error">Digite um CEP completo!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Cidade:" label-for="empresa-cidade">
                        <b-form-input id="empresa-cidade" type="text"
                            v-model="empresa.cidade" required
                            placeholder="Informe o Cidade do empresa."
                            :class="{ 'inputError': $v.empresa.cidade.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.cidade.$touch"/>
                        <span class="error" v-if="!$v.empresa.cidade.required && $v.empresa.cidade.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="UF:" label-for="empresa-UF">
                        <b-form-select id="empresa-UF" :options="ufs" v-model="empresa.uf" 
                        :class="{ 'inputError': $v.empresa.uf.$error }"
                        class="textInput"
                        @keydown.tab="$v.empresa.uf.$touch"/>
                        <span class="error" v-if="!$v.empresa.uf.required && $v.empresa.uf.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Logradouro:" label-for="empresa-logradouro">
                        <b-form-input id="empresa-logradouro" type="text"
                            v-model="empresa.logradouro"
                            placeholder="Informe o logradouro do empresa."
                            :class="{ 'inputError': $v.empresa.logradouro.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.logradouro.$touch"/>
                        <span class="error" v-if="!$v.empresa.logradouro.required && $v.empresa.logradouro.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.empresa.logradouro.minLength && $v.empresa.logradouro.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-form-group label="Número:" label-for="empresa-numero">
                        <b-form-input id="empresa-numero" type="text"
                            v-model="empresa.numero"
                            placeholder="Nº"
                            :class="{ 'inputError': $v.empresa.numero.$error }"
                            class="textInput"
                            @keydown.tab="$v.empresa.numero.$touch"/>
                        <span class="error" v-if="!$v.empresa.numero.required && $v.empresa.numero.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Complemento:" label-for="empresa-complemento">
                        <b-form-input id="empresa-complemento" type="text"
                            v-model="empresa.complemento"
                            class="textInput"/>
                    </b-form-group>
                </div>
            </div>
            
            <b-button variant="outline-success" class="botaoInput" @click="save">Alterar</b-button>
        </b-form>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'empresas',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            quemRecebeu: '',
            nome: '',
            email: '',
            admins: [],
            admin: {},
            ativar: [
                { value: '1', text: 'Sim' },
                { value: '0', text: 'Não' }
            ],
            ufs: [
                { value: 'AC', text: 'Acre' },
                { value: 'AL', text: 'Alagoas' },
                { value: 'AP', text: 'Amapa' },
                { value: 'AM', text: 'Amazonas' },
                { value: 'BA', text: 'Bahia' },
                { value: 'CE', text: 'Ceará' },
                { value: 'DF', text: 'Distrito Federal' },
                { value: 'ES', text: 'Espirito Santo' },
                { value: 'GO', text: 'Goiás' },
                { value: 'MA', text: 'Maranhão' },
                { value: 'MT', text: 'Mato Grosso' },
                { value: 'MS', text: 'Mato Grosso do Sul' },
                { value: 'MG', text: 'Minas Gerais' },
                { value: 'PA', text: 'Para' },
                { value: 'PB', text: 'Paraíba' },
                { value: 'PR', text: 'Paraná' },
                { value: 'PE', text: 'Pernambuco' },
                { value: 'PI', text: 'Piauí' },
                { value: 'RJ', text: 'Rio de Janeiro' },
                { value: 'RN', text: 'Rio Grande do Norte' },
                { value: 'RS', text: 'Rio Grande do Sul' },
                { value: 'RO', text: 'Rondônia' },
                { value: 'RR', text: 'Roraima' },
                { value: 'SC', text: 'Santa Catarina' },
                { value: 'SP', text: 'São Paulo' },
                { value: 'SE', text: 'Sergipe' },
                { value: 'TO', text: 'Tocantins' }
            ],
            empresa: {},
            plano: {},
            planos: []
        }
    },
    validations: {
        empresa: {
            razao: {
                required,
                minLength: minLength(4)
            },
            cnpj: {
                required,
                minLength: minLength(14)
            },
            plano: {
                required
            },
            ativo: {
                required
            },
            telefone: {
                required,
                minLength: minLength(10)
            },
            email: {
                required,
                email
            },
            cep: {
                required,
                minLength: minLength(8)
            },
            cidade: {
                required
            },
            uf: {
                required
            },
            logradouro: {
                required,
                minLength: minLength(4)
            },
            numero: {
                required
            }
        }
    },
    methods: {
        searchCep () {
            this.$v.empresa.cep.$touch()
			if(this.empresa.cep.length == 9) {
				axios.get(`https://viacep.com.br/ws/${ this.empresa.cep }/json/`)
                .then( res => {
                    this.empresa.cidade = res.data.localidade
                    this.empresa.logradouro = res.data.logradouro
                    this.empresa.uf = res.data.uf
                    document.getElementById("empresa-logradouro").value = res.data.logradouro
                    document.getElementById("empresa-UF").value = res.data.uf
                    document.getElementById("empresa-cidade").value = res.data.localidade
                    document.getElementById("empresa-numero").focus()
                })
				.catch( error => console.log(error) )
			} else {
                document.getElementById("empresa-logradouro").value = ''
                document.getElementById("empresa-UF").value = ''
                document.getElementById("empresa-cidade").value = ''
            }
		},
         loadPlanos() {
            const url = `${baseApiUrl}/backend/planos.php`
            axios.get(url).then(res => {
                this.planos = res.data.map(plano => {
                    return { ...plano, value: plano.titulo, text: plano.titulo }
                })
            })
        },
        loadEmpresas() {
            const url = `${baseApiUrl}/backend/empresas.php?id=1`
            axios.get(url).then(res => {
                this.empresa = res.data[0]
            })
        },
        save() {
            this.$v.empresa.$touch()
            if(!this.$v.empresa.$error){
                const id = `?id=${this.empresa.id}`

                axios['put'](`${baseApiUrl}/backend/empresas.php${id}`, this.empresa)
                .then(() => {

                    axios.get(`${baseApiUrl}/backend/isAdmin.php`)
                    .then(res => {
                        this.admins = res.data
                        for (let i = 0; i < this.admins.length; i++) {
                            this.admin = this.admins[i]
                            const tipo = `?tipo=alteraEmpresa`
                            const destinoEmail = `&destinoEmail=${this.admin.email}`
                            const destinoNome = `&destinoNome=${this.admin.nome}`
                            const razao = `&razao=${this.empresa.razao}`
                            const usuarioAtivo = `&usuarioAtivo=${this.nome}`
                            axios.get(`${baseApiUrl}/backend/mailEmpresa.php${tipo}${destinoEmail}${destinoNome}${razao}${usuarioAtivo}`).then({})
                        }
                    })
                    

                    

                    this.$toasted.global.defaultSuccess({ message : 'Empresa alterada com sucesso!' })
                    this.reset()
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                })
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadPlanos()
        this.loadEmpresas()
    }
}
</script>

<style>
.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

label {
    font-size: 0.8rem;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border-bottom: 1px solid #f57f6c !important;
}
</style>